const OPEN_MODAL = 'scratch-gui/modals/OPEN_MODAL';
const CLOSE_MODAL = 'scratch-gui/modals/CLOSE_MODAL';

const MODAL_BACKDROP_LIBRARY = 'backdropLibrary';
const MODAL_COSTUME_LIBRARY = 'costumeLibrary';
const MODAL_DEBUG = 'debugModal';
const MODAL_EXTENSION_LIBRARY = 'extensionLibrary';
const MODAL_LOADING_PROJECT = 'loadingProject';
const MODAL_TELEMETRY = 'telemetryModal';
const MODAL_SOUND_LIBRARY = 'soundLibrary';
const MODAL_SPRITE_LIBRARY = 'spriteLibrary';
const MODAL_SOUND_RECORDER = 'soundRecorder';
const MODAL_CONNECTION = 'connectionModal';
const MODAL_TIPS_LIBRARY = 'tipsLibrary';
const MODAL_RESOURCES_LIBRARY = 'resourcesLibrary';
const MODAL_HARDWARE_UPLOAD = 'hardwareUploadModal';
const MODAL_TRAINER_DEVICE = 'trainerDeviceModal';
const MODAL_ML_ENVIRONMENT = 'mlEnvironmentModal';
const MODAL_MODEL_LOADING = 'modelLoadingModal';
const MODAL_ACCOUNT_SETTINGS = 'accountSettingsModal';

const initialState = {
    [MODAL_BACKDROP_LIBRARY]: false,
    [MODAL_COSTUME_LIBRARY]: false,
    [MODAL_DEBUG]: false,
    [MODAL_EXTENSION_LIBRARY]: false,
    [MODAL_LOADING_PROJECT]: false,
    [MODAL_TELEMETRY]: false,
    [MODAL_SOUND_LIBRARY]: false,
    [MODAL_SPRITE_LIBRARY]: false,
    [MODAL_SOUND_RECORDER]: false,
    [MODAL_CONNECTION]: false,
    [MODAL_TIPS_LIBRARY]: false,
    [MODAL_RESOURCES_LIBRARY]: false,
    [MODAL_HARDWARE_UPLOAD]: false,
    [MODAL_TRAINER_DEVICE]: false,
    [MODAL_ML_ENVIRONMENT]: false,
    [MODAL_ACCOUNT_SETTINGS]: false,
    [MODAL_MODEL_LOADING]: false
};

const reducer = function (state, action) {
    if (typeof state === 'undefined') state = initialState;
    switch (action.type) {
    case OPEN_MODAL:
        return Object.assign({}, state, {
            [action.modal]: true
        });
    case CLOSE_MODAL:
        return Object.assign({}, state, {
            [action.modal]: false
        });
    default:
        return state;
    }
};
const openModal = function (modal) {
    return {
        type: OPEN_MODAL,
        modal: modal
    };
};
const closeModal = function (modal) {
    return {
        type: CLOSE_MODAL,
        modal: modal
    };
};
const openBackdropLibrary = function () {
    return openModal(MODAL_BACKDROP_LIBRARY);
};
const openCostumeLibrary = function () {
    return openModal(MODAL_COSTUME_LIBRARY);
};
const openDebugModal = function () {
    return openModal(MODAL_DEBUG);
};
const openExtensionLibrary = function () {
    return openModal(MODAL_EXTENSION_LIBRARY);
};
const openLoadingProject = function () {
    return openModal(MODAL_LOADING_PROJECT);
};
const openTelemetryModal = function () {
    return openModal(MODAL_TELEMETRY);
};
const openSoundLibrary = function () {
    return openModal(MODAL_SOUND_LIBRARY);
};
const openSpriteLibrary = function () {
    return openModal(MODAL_SPRITE_LIBRARY);
};
const openSoundRecorder = function () {
    return openModal(MODAL_SOUND_RECORDER);
};
const openConnectionModal = function () {
    return openModal(MODAL_CONNECTION);
};
const openTipsLibrary = function () {
    return openModal(MODAL_TIPS_LIBRARY);
};
const openResourcesLibrary = function () {
    return openModal(MODAL_RESOURCES_LIBRARY);
};
const closeBackdropLibrary = function () {
    return closeModal(MODAL_BACKDROP_LIBRARY);
};
const closeCostumeLibrary = function () {
    return closeModal(MODAL_COSTUME_LIBRARY);
};
const closeDebugModal = function () {
    return closeModal(MODAL_DEBUG);
};
const closeExtensionLibrary = function () {
    return closeModal(MODAL_EXTENSION_LIBRARY);
};
const closeLoadingProject = function () {
    return closeModal(MODAL_LOADING_PROJECT);
};
const closeTelemetryModal = function () {
    return closeModal(MODAL_TELEMETRY);
};
const closeSpriteLibrary = function () {
    return closeModal(MODAL_SPRITE_LIBRARY);
};
const closeSoundLibrary = function () {
    return closeModal(MODAL_SOUND_LIBRARY);
};
const closeSoundRecorder = function () {
    return closeModal(MODAL_SOUND_RECORDER);
};
const closeTipsLibrary = function () {
    return closeModal(MODAL_TIPS_LIBRARY);
};
const closeResourcesLibrary = function () {
    return closeModal(MODAL_RESOURCES_LIBRARY);
};
const closeConnectionModal = function () {
    return closeModal(MODAL_CONNECTION);
};
const openHardwareUploadModal = function () {
    return openModal(MODAL_HARDWARE_UPLOAD);
};
const closeHardwareUploadModal = function () {
    return closeModal(MODAL_HARDWARE_UPLOAD);
};
const openTrainerDeviceModal = function () {
    return openModal(MODAL_TRAINER_DEVICE);
};
const closeTrainerDeviceModal = function () {
    return closeModal(MODAL_TRAINER_DEVICE);
};
const openMLEnvironment = function () {
    return openModal(MODAL_ML_ENVIRONMENT);
};
const closeMLEnvironment = function () {
    return closeModal(MODAL_ML_ENVIRONMENT);
};
const openAccountSettings = function () {
    return openModal(MODAL_ACCOUNT_SETTINGS);
};
const closeAccountSettings = function () {
    return closeModal(MODAL_ACCOUNT_SETTINGS);
};
const openModelLoadingModal = function () {
    return openModal(MODAL_MODEL_LOADING);
};
const closeModelLoadingModal = function () {
    return closeModal(MODAL_MODEL_LOADING);
};

export {
    reducer as default,
    initialState as modalsInitialState,
    openBackdropLibrary,
    openCostumeLibrary,
    openDebugModal,
    openExtensionLibrary,
    openLoadingProject,
    openSoundLibrary,
    openSpriteLibrary,
    openSoundRecorder,
    openTelemetryModal,
    openTipsLibrary,
    openResourcesLibrary,
    openConnectionModal,
    closeBackdropLibrary,
    closeCostumeLibrary,
    closeDebugModal,
    closeExtensionLibrary,
    closeLoadingProject,
    closeSpriteLibrary,
    closeSoundLibrary,
    closeSoundRecorder,
    closeTelemetryModal,
    closeTipsLibrary,
    closeResourcesLibrary,
    closeConnectionModal,
    openHardwareUploadModal,
    closeHardwareUploadModal,
    openTrainerDeviceModal,
    closeTrainerDeviceModal,
    openMLEnvironment,
    closeMLEnvironment,
    openAccountSettings,
    closeAccountSettings,
    openModelLoadingModal,
    closeModelLoadingModal
};
